module.exports = __webpack_public_path__ + "static/media/original-charts-3-mobile.a66ee6cf.jpg";